<template>
  <div class="landing-page">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="stars"></div>
      <div class="floating-shapes">
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        <div class="shape shape-3"></div>
        <div class="shape shape-4"></div>
      </div>
      <div class="floor-line"></div>
    </div>

         <!-- 头部 -->
     <header class="header">
       <div class="logo">芝麻开花智能写作平台</div>
               <div class="notification">
          <Bell class="notification-icon" />
                    <div class="notification-container">
                       <div class="notification-list" :style="{ transform: `translateY(-${currentNotificationIndex * 30}px)` }">
              <div 
                v-for="(notification, index) in notifications" 
                :key="index" 
                class="notification-item"
                :class="{ active: index === currentNotificationIndex }"
              >
                {{ notification.text }}
              </div>
            </div>
         </div>
       </div>
     </header>

    <!-- 主要内容 -->
    <main class="main-content">
      <div class="hero-section">
        <h1 class="main-headline">国家开放大学·论文生成系统</h1>
        <div class="description">
          <p>500万学员正在使用完成毕业论文 | 可自定义目录 | 低查重率</p>
          <p>自动生成Word格式论文 | 格式自动生成 | 可直接下载打印</p>
        </div>
        
                 <div class="action-buttons">
           <button class="btn btn-primary" @click="goToWriting">
             <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" fill="currentColor"/>
             </svg>
             生成论文
           </button>
           <button class="btn btn-secondary" @click="showOrderDownload">
             <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" fill="currentColor"/>
             </svg>
             订单下载
           </button>
          <button class="btn btn-info" @click="goToUserGuide">
            <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z" fill="currentColor"/>
            </svg>
            用前必看
          </button>
         </div>
      </div>

      <div class="sample-section">
        <h2 class="section-title">范文</h2>
        <div class="image-gallery">
          <div class="image-item" @click="goToTemplateGallery">
            <img src="@/assets/moban/1.jpg" alt="示例图片1" />
          </div>
          <div class="image-item" @click="goToTemplateGallery">
            <img src="@/assets/moban/2.jpg" alt="示例图片2" />
          </div>
          <div class="image-item" @click="goToTemplateGallery">
            <img src="@/assets/moban/3.jpg" alt="示例图片3" />
          </div>
        </div>
      </div>
    </main>

    <!-- 订单查询弹窗 -->
    <OrderQuery :visible="orderQueryVisible" @update:visible="orderQueryVisible = $event" />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ref, onMounted, onUnmounted } from 'vue'
import OrderQuery from '@/components/OrderQuery.vue'
import { Bell } from '@element-plus/icons-vue'

const router = useRouter()
const orderQueryVisible = ref(false)

// 通知相关数据
const notifications = ref<Array<{text: string, time: string}>>([])
const currentNotificationIndex = ref(0)
let notificationTimer: number | null = null

// 生成随机通知数据
const generateNotifications = () => {
  const topics = [
    '新课标',
    '人工智能',
    '数字化转型',
    '可持续发展',
    '科技创新',
    '教育现代化',
    '数字经济发展',
    '绿色环保',
    '智慧城市',
    '文化传承',
    '乡村振兴',
    '医疗健康',
    '金融科技',
    '生态环境保护',
    '社会治理',
    '区块链技术',
    '云计算应用',
    '大数据分析',
    '物联网发展',
    '5G技术应用',
    '智能制造',
    '新能源技术',
    '生物科技',
    '航天技术',
    '量子计算',
    '虚拟现实',
    '增强现实',
    '机器学习',
    '深度学习',
    '自然语言处理'
  ]
  
  const timeOptions = ['1分钟前', '5分钟前', '1小时前']
  const newNotifications = []
  
  // 生成6条随机通知
  const notificationCount = 6
  
  for (let i = 0; i < notificationCount; i++) {
    const topic = topics[Math.floor(Math.random() * topics.length)]
    const time = timeOptions[Math.floor(Math.random() * timeOptions.length)]
    
    newNotifications.push({
      text: `${time},论文《${topic}*****》生成成功`,
      time: time
    })
  }
  
  notifications.value = newNotifications
}

// 开始滚动通知
const startNotificationScroll = () => {
  notificationTimer = window.setInterval(() => {
    currentNotificationIndex.value = (currentNotificationIndex.value + 1) % notifications.value.length
  }, 3000) // 每3秒切换一次
}

// 定期刷新通知数据
let refreshTimer: number | null = null
const startRefreshTimer = () => {
  refreshTimer = window.setInterval(() => {
    generateNotifications()
    currentNotificationIndex.value = 0
  }, 30000) // 每30秒刷新一次通知数据
}

// 停止滚动通知
const stopNotificationScroll = () => {
  if (notificationTimer) {
    clearInterval(notificationTimer)
    notificationTimer = null
  }
}

// 停止刷新定时器
const stopRefreshTimer = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer)
    refreshTimer = null
  }
}





const goToWriting = () => {
  // 获取当前URL的所有查询参数
  const urlParams = new URLSearchParams(window.location.search)
  
  // 如果存在查询参数，则在跳转时携带所有参数
  if (urlParams.toString()) {
    router.push(`/writing?${urlParams.toString()}`)
  } else {
    router.push('/writing')
  }
}

const goToUserGuide = () => {
  router.push('/user-guide')
}

const goToTemplateGallery = () => {
  router.push('/template-gallery')
}

const showOrderDownload = () => {
  orderQueryVisible.value = true
}

// 组件挂载时初始化
onMounted(() => {
  generateNotifications()
  startNotificationScroll()
  startRefreshTimer()
})

// 组件卸载时清理定时器
onUnmounted(() => {
  stopNotificationScroll()
  stopRefreshTimer()
})
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 背景装饰 */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.stars {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.3), transparent),
                    radial-gradient(2px 2px at 40px 70px, rgba(255,255,255,0.2), transparent),
                    radial-gradient(1px 1px at 90px 40px, rgba(255,255,255,0.4), transparent),
                    radial-gradient(1px 1px at 130px 80px, rgba(255,255,255,0.3), transparent),
                    radial-gradient(2px 2px at 160px 30px, rgba(255,255,255,0.2), transparent);
  background-repeat: repeat;
  background-size: 200px 100px;
  animation: twinkle 4s ease-in-out infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
}

.floating-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(10px);
}

.shape-1 {
  width: 80px;
  height: 60px;
  bottom: 20%;
  left: 10%;
  animation: float 6s ease-in-out infinite;
}

.shape-2 {
  width: 120px;
  height: 40px;
  bottom: 30%;
  right: 15%;
  animation: float 8s ease-in-out infinite reverse;
}

.shape-3 {
  width: 60px;
  height: 80px;
  bottom: 15%;
  left: 60%;
  animation: float 7s ease-in-out infinite;
}

.shape-4 {
  width: 100px;
  height: 50px;
  bottom: 25%;
  right: 5%;
  animation: float 9s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(5deg); }
}

.floor-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

/* 头部 */
.header {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

 .notification {
   display: flex;
   align-items: center;
   gap: 10px;
   background: rgba(255, 255, 255, 0.15);
   padding: 10px 18px;
   border-radius: 25px;
   backdrop-filter: blur(15px);
   font-size: 14px;
   overflow: hidden;
   border: 1px solid rgba(255, 255, 255, 0.2);
   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
   transition: all 0.3s ease;
 }

 .notification:hover {
   background: rgba(255, 255, 255, 0.2);
   transform: translateY(-1px);
   box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
 }

               .notification-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      color: white;
    }

 .notification-container {
   height: 30px;
   overflow: hidden;
   position: relative;
 }

 .notification-list {
   transition: transform 0.5s ease-in-out;
 }

 .notification-item {
   height: 30px;
   line-height: 30px;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 300px;
   transition: opacity 0.3s ease;
   opacity: 0.8;
 }

   .notification-item.active {
    opacity: 1;
    font-weight: 600;
  }

/* 主要内容 */
.main-content {
  position: relative;
  z-index: 10;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 40px;
  text-align: center;
}

.hero-section {
  margin-bottom: 80px;
}

.main-headline {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 30px;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.description {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.description p {
  margin-bottom: 10px;
}

/* 按钮 */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 80px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  color: white;
}

.btn-primary {
  background: linear-gradient(135deg, #ff6b35, #f7931e);
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(255, 107, 53, 0.4);
}

.btn-secondary {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
  box-shadow: 0 8px 25px rgba(79, 172, 254, 0.3);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(79, 172, 254, 0.4);
}

.btn-info {
  background: linear-gradient(135deg, #a855f7, #8b5cf6);
  box-shadow: 0 8px 25px rgba(168, 85, 247, 0.3);
}

.btn-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(168, 85, 247, 0.4);
}


 .btn-icon {
   width: 20px;
   height: 20px;
   flex-shrink: 0;
 }

/* 范文区域容器 */
.sample-section {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border-radius: 20px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 1000px;
  margin: 0 auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 28px;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 图片画廊 */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.image-item {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease;
  overflow: hidden;
  cursor: pointer;
}

.image-item:hover {
  transform: translateY(-3px);
}

.image-item img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
}

.image-item img:hover {
  transform: scale(1.03);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 20px;
    flex-direction: column;
    gap: 20px;
  }
  
  .main-content {
    padding: 40px 20px;
  }
  
  .main-headline {
    font-size: 32px;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .sample-section {
    padding: 30px 20px;
    margin: 0 20px;
  }
  
  .section-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .image-gallery {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .image-item {
    padding: 10px;
  }
  
  .image-item img {
    height: 250px;
  }
}
</style>
